import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Sparkles, Activity, Wind } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-24 bg-earth-darker text-cream relative overflow-hidden" data-id="element-152">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-accent/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-153" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-earth-light/5 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-154" />

      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center relative z-10" data-id="element-155">
        <FadeIn data-id="element-156">
          <span className="text-accent font-semibold tracking-widest uppercase text-sm mb-4 block" data-id="element-157">
            El Mecanismo Único
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mb-10 text-white" data-id="element-158">
            LA SECUENCIA NEURO-SOOTHE
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-159">
          <p className="text-xl md:text-2xl text-cream-dark/90 leading-relaxed mb-16 font-light" data-id="element-160">
            He desarrollado un protocolo de 3 pasos que utiliza la presión
            biomecánica y la frecuencia auditiva para "engañar" al sistema
            nervioso del bebé, obligándolo a relajarse y permitiendo que su
            intestino libere el gas atrapado de forma natural e inmediata.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-161">
          <div className="inline-flex items-center gap-3 bg-white/10 px-8 py-4 rounded-full backdrop-blur-sm border border-white/20" data-id="element-162">
            <Sparkles className="w-6 h-6 text-accent" data-id="element-163" />
            <span className="text-xl font-medium" data-id="element-164">
              No es magia, es ciencia táctil.
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
}